import React from "react";
import { useNavigate } from "react-router-dom";
import type { AffiliateClass } from "../../../../interfaces/affiliateClasses";
import { useLocalization } from "../../../../stores/localizationContext";
import { formatSessionDate } from "../../../../utils";
import "./ClassCard.scss";

interface ClassCardProps {
  classData: AffiliateClass;
}

const ClassCard: React.FC<ClassCardProps> = ({ classData }) => {
  const { t, lang } = useLocalization();
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`/${lang}/admin/classes/${classData.class_id}`);
  };

  const locale = lang === "ar" ? "ar-EG" : "en-US";

  const subtitleParts = [
    t(classData.grade_localization_key, classData.grade_localization_key),
    classData.class_semester_localization_key
      ? t(classData.class_semester_localization_key, classData.class_semester_localization_key)
      : null,
    t(classData.class_type_localization_key, classData.class_type),
  ].filter(Boolean);

  const nextSession = classData.next_session_date
    ? formatSessionDate(classData.next_session_date, locale)
    : "—";

  const nagwaStudents = classData.standard_seats_reserved ?? 0;
  const affiliateStudents = classData.affiliate_seats_reserved ?? 0;

  return (
    <div className="class-card" onClick={handleClick} role="button" tabIndex={0} onKeyDown={(e) => e.key === "Enter" && handleClick()}>
      <h2 className="class-card__title">{classData.class_title}</h2>
      <p className="class-card__subtitle">{subtitleParts.join(" • ")}</p>

      <div className="class-card__row">
        <span className="class-card__value">{nextSession}</span>
      </div>

      <div className="class-card__row">
        <span className="class-card__label">{t("students_number", "Students Number")}:</span>
        <span className="class-card__value">
          {t("nagwa_students", "Nagwa Students")}: {nagwaStudents}
          {" • "}
          {t("affiliate_students_label")}: {affiliateStudents}
        </span>
      </div>
    </div>
  );
};

export default ClassCard;
